module.exports = react;


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 48
// module chunks = 0